import {
  Button,
  Center,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { login } from "@/api/auth";
import { useAuthStore } from "@/stores/auth";
import { notify } from "@/lib/notify";
import { PageTitle } from "@/components/PageTitle";

// Metin SUNUCUDAN değil buradan geliyor. API mesajları İngilizce ve teknik ("Invalid email or
// password"); kullanıcıya olduğu gibi basınca giriş ekranı yarı İngilizce görünüyordu. Uygulama
// da aynı şekilde kendi metnini yazıyor.
const failureText = (error) => {
  const status = error?.response?.status;

  if (!error?.response) {
    return "Sunucuya ulaşılamadı. Bağlantını kontrol edip tekrar dene.";
  }

  if (status === 401 || status === 400) {
    return "E-posta veya şifre hatalı.";
  }

  if (status === 429) {
    return "Çok fazla deneme yapıldı. Kısa bir süre bekleyip tekrar dene.";
  }

  return "Şu an giriş yapılamıyor. Birazdan tekrar dene.";
};

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const setAuth = useAuthStore((state) => state.setAuth);
  const token = useAuthStore((state) => state.token);
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: login,
    onSuccess: ({ token, user }) => {
      setAuth({ token, user });
      navigate("/");
    },
    onError: (error) => notify.error(failureText(error)),
  });

  const submit = () => mutation.mutate({ email, password });

  // Açılıştaki refresh oturumu geri getirmiş olabilir (SessionGate). Bu durumda giriş formunu
  // göstermenin anlamı yok — kullanıcı zaten içeride, forma bakması kafa karıştırırdı.
  if (token) {
    return <Navigate to="/" replace />;
  }

  return (
    <Center
      mih="100vh"
      p="md"
      style={{
        background:
          "linear-gradient(135deg, var(--mantine-color-chocolate-0), var(--mantine-color-gray-1))",
      }}
    >
      <PageTitle>Giriş</PageTitle>
      <Paper withBorder shadow="md" radius="lg" p={32} w={420} maw="100%">
        <Stack align="center" gap={4} mb="lg">
          <img src="/noxus-emblem.svg" alt="Noxus" width={64} height={64} />
          <Text fw={700} size="xl" mt="sm">
            Noxus Panel
          </Text>
          <Text size="sm" c="dimmed">
            Devam etmek için giriş yapın
          </Text>
        </Stack>

        <form
          onSubmit={(event) => {
            event.preventDefault();
            submit();
          }}
        >
          <Stack>
            <TextInput
              label="E-posta"
              type="email"
              autoComplete="email"
              placeholder="ornek@firma.com"
              value={email}
              onChange={(event) => setEmail(event.currentTarget.value)}
            />
            <PasswordInput
              label="Şifre"
              autoComplete="current-password"
              placeholder="••••••••"
              value={password}
              onChange={(event) => setPassword(event.currentTarget.value)}
            />
            <Button
              fullWidth
              type="submit"
              size="md"
              mt="sm"
              loading={mutation.isPending}
              disabled={!email || !password}
            >
              Giriş Yap
            </Button>
          </Stack>
        </form>
      </Paper>
    </Center>
  );
}
